import React from 'react'
import TitleBg from '../components/TitleBg'
import bg from '../images/ContactUsBg.png';


function FailedPaymentTitle() {
  return (
    <TitleBg
        title='Failed Payments'
        bgImg={bg}

    />
  )
}

export default FailedPaymentTitle